import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RepeatStrategy } from '../../../manageMentorship/types/repeatStrategy';
export function useStrategyItems() {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    const repeatEvery = watch('recurringSession.repeat.every');
    const inflection = repeatEvery && parseInt(repeatEvery) > 1 ? 'plural' : 'singular';
    const repeatStrategyItems = useMemo(() => [
        {
            label: t(`mentorship.form.recurring_session.frequency.options.custom.repeat_at.${inflection}.day`),
            value: RepeatStrategy.Daily
        },
        {
            label: t(`mentorship.form.recurring_session.frequency.options.custom.repeat_at.${inflection}.week`),
            value: RepeatStrategy.Weekly
        },
        {
            label: t(`mentorship.form.recurring_session.frequency.options.custom.repeat_at.${inflection}.month`),
            value: RepeatStrategy.Monthly
        }
    ], [t, inflection]);
    return repeatStrategyItems;
}
